import { PaginationType } from "../../Types/APITypes";
import API from "./API";
import {
  AdminListResponse,
  AdminShowResponse,
  CreateAdminPayload,
  UpdateAdminPayload,
} from "../../Types/admins";

class AdminAPI extends API {
  static get_admins = (pagination?: PaginationType) => {
    return this.getRequest(
        `manage/admins?page=${pagination?.current_page || 1}&per_page=${pagination?.per_page || 10}${pagination?.search_word ? `&query=${pagination.search_word}` : ""}`,
        true
    ) as unknown as Promise<AdminListResponse>;
  };

  static get_admin = (id: number) => {
    return this.getRequest(`manage/admins/${id}/show`, true) as unknown as Promise<AdminShowResponse>;
  };

  static create_admin = (data: CreateAdminPayload) => {
    if (data.avatar) {
      const form = new FormData();
      form.append("email", data.email);
      form.append("password", data.password);
      form.append("first_name", data.first_name);
      form.append("last_name", data.last_name);
      form.append("role_id", String(data.role_id));
      form.append("avatar", data.avatar);
      return this.postFileRequest("manage/admins/create", form, true);
    }
    const { avatar, ...rest } = data;
    return this.postRequest("manage/admins/create", rest, true);
  };

  static update_admin = (id: number, data: UpdateAdminPayload) => {
    if (data.avatar) {
      const form = new FormData();
      if (data.first_name) form.append("first_name", data.first_name);
      if (data.last_name) form.append("last_name", data.last_name);
      form.append("avatar", data.avatar);
      return this.putFileRequest(`manage/admins/${id}/update`, form, true);
    }
    const { avatar, ...rest } = data;
    return this.putRequest(`manage/admins/${id}/update`, rest, true);
  };

  static delete_admin = (id: number) => {
    return this.deleteRequest(`manage/admins/${id}`, {}, true);
  };

  static block_admin = (id: number, blocked: boolean) => {
    return this.putRequest(`manage/admins/${id}/block`, { blocked }, true);
  };
}

export default AdminAPI;


